import { type Control, Controller, type FieldValues, type Path, type PathValue } from 'react-hook-form';
import Select, { type SelectProps } from '../Select';

interface Props<T extends FieldValues> extends SelectProps {
  name: Path<T>;
  control: Control<T>;
  validate?: (value: PathValue<T, Path<T>>, formValues: T) => string | boolean;
}

export default function <T extends FieldValues>({ name, control, ...props }: Props<T>) {
  return (
    <Controller
      name={name}
      control={control}
      rules={{
        required: props.isRequired ? 'Required' : false,
        validate: props.validate || undefined,
      }}
      render={({ field, fieldState: { error } }) => <Select {...props} {...field} error={error?.message} />}
    />
  );
}
